<template>
  <div class="flex flex-col">
    <slot name="belowHeader" />
    <div v-if="$slots.banner" class="z-49 sm:top-(--headerHeight)">
      <slot name="banner" />
    </div>
    <div class="grow xl:px-10 xl:pt-10">
      <div
        class="mx-auto max-w-(--breakpoint-xl) rounded-lg bg-surface-level-1 py-4 sm:py-12">
        <div class="single-page-grid">
          <!-- single page layout slot start -->
          <!-- we only have one exception layout here which is kind of the picture detail page, everything else is placed in the center of this -->
          <slot></slot>
          <!-- /single page layout slot end -->
        </div>
      </div>
    </div>
    <DpaNewsFooter :has-disclaimer="true" />
  </div>
</template>

<script setup lang="ts">
import { provide } from "vue";

import DpaNewsFooter from "@/components/shared/DpaNewsFooter/DpaNewsFooter.vue";
import { SinglePageClass } from "@/symbols.ts";

provide(SinglePageClass, "span-full");
</script>
